<template>
    <div class="login-panel d-flex flex-column">
        <div class="">
            <div class="d-flex flex-column">
                <div class="d-flex flex-column logo-container">
                    <img src="../../assets/naglotech_logo.png" class="logo-img">
                    <span class="logo-text">Secure File Management System</span>
                </div>
                <div class="login-container mt-3">
                    <form @submit.prevent="onSubmit">
                        <!-- <div class="form-group">
                            <label for="txt_username">Username</label>
                            <div class="input-group">
                                <div class="input-group-prepend">
                                    <span class="input-group-text">
                                        <font-awesome-icon :icon="['fad', 'user']" fixed-width></font-awesome-icon>
                                    </span>
                                </div>
                                <input v-model="username" type="text" class="form-control" placeholder="Username" id="txt_username">
                            </div>
                        </div> -->
                        <text-input :id="'txt_username'" :iconPrepend="'user'" :label="'Username'" :placeholder="'Username'" v-model="username"></text-input>
                        <div class="form-group">
                            <label for="txt_password">Password</label>
                            <div class="input-group">
                                <div class="input-group-prepend">
                                    <div class="input-group-text">
                                        <font-awesome-icon :icon="['fad', 'key']" fixed-width></font-awesome-icon>
                                    </div>
                                </div>
                                <input v-model="password" type="password" class="form-control password-input" placeholder="Password" id="txt_password">
                                <div class="input-group-append" @mousedown="showPassword" @mouseup="hidePassword" @mouseleave="hidePassword">
                                    <span class="input-group-text">
                                        <font-awesome-icon :icon="['fad', 'eye']" fixed-width></font-awesome-icon>
                                    </span>
                                </div>
                            </div>
                        </div>
                        <div>
                            <button type="submit" class="btn float-right" :class="{'btn-primary': !loginSuccess, 'btn-success': loginSuccess }">
                                <span v-if="!loginSuccess">Login</span>
                                <span v-if="loginSuccess">Success</span>
                                <font-awesome-icon v-if="isLoading && !loginSuccess" :icon="['fad', 'spinner']" fixed-width spin></font-awesome-icon>
                            </button>
                        </div>
                    </form>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import TextInput from '../forms/text-input'

export default {
    data() {
        return {
            username: '',
            password: '',
            isLoading: false,
            loginSuccess: false
        }
    },
    components: {
        TextInput
    },
    computed: {
        passwordInput() {
            return this.$el.getElementsByClassName('password-input')
        },
        loginButton() {
            return this.$el.querySelector('button[type="submit"]')
        }
    },
    methods: {
        showPassword() {
            this.passwordInput[0].type = 'text'
        },
        hidePassword() {
            this.passwordInput[0].type = 'password'
        },
        onSubmit() {
            //will handle login, for now just set route etc.
            this.isLoading = true
            let comp = this
            setTimeout(function() {
                console.log(comp.loginButton)
                comp.loginSuccess = true
                setTimeout(function() {
                    comp.$store.state.loggedIn = true
                    comp.$router.push('/')
                }, 300)
            }, 1000)
        }
    }
}
</script>
<style lang="scss" scoped>
@import '../../styles/bootstrap/_custom';

.logo-container {
    font-size: 1.5em;
    .logo-img {
        height: auto;
        max-width: 500px;
    }
    .logo-text {
        margin-top: 0.5em;
        text-transform: uppercase;
        color: #aaaaaa;
        text-align: center;
    }
}

.input-group-text {
    color: $success;
}

</style>


// WEBPACK FOOTER //
// src/components/login/login-panel.vue